"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.find.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _drawer = require("@citrus/drawer");
var _layout = require("@citrus/layout");
var _banner = require("@citrus/banner");
var _PctyQuestionBuilderQuestionBank = _interopRequireDefault(require("./PctyQuestionBuilder.QuestionBank.Selection"));
var _PctyQuestionBuilderQuestionBank2 = _interopRequireDefault(require("./PctyQuestionBuilder.QuestionBank.Preview"));
var _lodash = _interopRequireDefault(require("lodash.orderby"));
require("./index.css");
var _p;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilderQuestionBankDrawer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderQuestionBankDrawer, _Component);
  var _super = _createSuper(PctyQuestionBuilderQuestionBankDrawer);
  function PctyQuestionBuilderQuestionBankDrawer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderQuestionBankDrawer);
    _this = _super.call(this, props);
    _this.state = {
      showBanner: false,
      showPreview: false,
      selectedQbItemIds: [],
      questionBankData: [],
      // don't change!
      categoryOptions: [] // don't change!
    };

    _this.onQuestionsChange = _this.onQuestionsChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickAddQuestions = _this.onClickAddQuestions.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickBack = _this.onClickBack.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickPreview = _this.onClickPreview.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickCancel = _this.onClickCancel.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderQuestionBankDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var categories = this.props.questionBankQuestions.map(function (item) {
        return item.questionBankCategoryDescription;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      var categoryOptions = categories.sort().map(function (c) {
        return {
          value: c,
          label: c
        };
      });
      var questionBankData = (0, _lodash.default)(this.props.questionBankQuestions, ['questionBankCategoryDescription', 'questionText']);
      this.setState({
        questionBankData: questionBankData,
        categoryOptions: categoryOptions
      });
    }
  }, {
    key: "resetViews",
    value: function resetViews() {
      this.setState({
        selectedQbItemIds: [],
        showPreview: false
      });
    }
  }, {
    key: "onQuestionsChange",
    value: function onQuestionsChange(items) {
      this.setState({
        selectedQbItemIds: items
      });
    }
  }, {
    key: "onClickAddQuestions",
    value: function onClickAddQuestions() {
      var _this2 = this;
      var questions = this.state.selectedQbItemIds.map(function (sq) {
        var qbItem = _this2.state.questionBankData.find(function (x) {
          return x.citrusElement.id === sq;
        });
        return qbItem.citrusElement;
      });
      this.resetViews();
      this.props.onAddQuestions(questions);
    }
  }, {
    key: "onClickBack",
    value: function onClickBack() {
      this.setState({
        showPreview: false
      });
    }
  }, {
    key: "onClickPreview",
    value: function onClickPreview() {
      this.setState({
        showPreview: true
      });
    }
  }, {
    key: "onClickCancel",
    value: function onClickCancel() {
      this.resetViews();
      this.props.onCancel();
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      if (!this.state.showPreview) return null;
      return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderQuestionBank2.default, {
        questionBankData: this.state.questionBankData,
        selectedQbItemIds: this.state.selectedQbItemIds,
        onQuestionsChange: this.onQuestionsChange
      });
    }
  }, {
    key: "renderQuestionBank",
    value: function renderQuestionBank() {
      if (this.state.showPreview) return null;
      return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderQuestionBank.default, {
        questionBankData: this.state.questionBankData,
        selectedQbItemIds: this.state.selectedQbItemIds,
        excludedQbItemIds: this.props.existingQuestionIds,
        categoryOptions: this.state.categoryOptions,
        onQuestionsChange: this.onQuestionsChange
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var defaultFunction = function defaultFunction() {};
      var hasSelectedItems = this.state.selectedQbItemIds.length > 0;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_drawer.Drawer, {
        id: "question-bank-drawer",
        onClose: defaultFunction,
        size: 'large',
        padding: true,
        open: !!this.props.open
      }, /*#__PURE__*/_react.default.createElement(_layout.Header, {
        renderActionArea: function renderActionArea() {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
            id: "question-bank-cancel",
            onClick: _this3.onClickCancel
          }, "Cancel"), _this3.state.showPreview ? /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
            id: "question-bank-back",
            onClick: _this3.onClickBack,
            type: "outline"
          }, "Back") : /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
            id: "question-bank-preview",
            onClick: _this3.onClickPreview,
            disabled: !hasSelectedItems,
            type: "outline"
          }, "Preview"), /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
            id: "question-bank-add",
            disabled: !hasSelectedItems,
            onClick: _this3.onClickAddQuestions
          }, "Add"));
        },
        title: this.state.showPreview ? "Preview Questions" : "Question Banks"
      }), /*#__PURE__*/_react.default.createElement(_banner.Banner, {
        automationId: "error-banner",
        id: "error-banner",
        onDismiss: function onDismiss() {
          return console.log('onDismiss');
        },
        type: "error",
        visible: this.state.showBanner
      }, _p || (_p = /*#__PURE__*/_react.default.createElement("p", null, 'Pick something already!'))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, this.renderQuestionBank(), this.renderPreview()))));
    }
  }]);
  return PctyQuestionBuilderQuestionBankDrawer;
}(_react.Component);
PctyQuestionBuilderQuestionBankDrawer.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onAddQuestions: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  questionBankQuestions: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  existingQuestionIds: _propTypes.default.arrayOf(_propTypes.default.any).isRequired
};
var _default = exports.default = PctyQuestionBuilderQuestionBankDrawer;